import {Component} from '@angular/core';

@Component({
	selector: 'app-gestion-navette',
	templateUrl: './gestion-navette.component.html',
	styleUrl: './gestion-navette.component.scss'
})
export class GestionNavetteComponent {
}
